module.exports = __webpack_public_path__ + "img/BWBV.3a385350.png";